/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/MarketFeedBingCognitive', 'model/BingCognitiveSearchData'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/MarketFeedBingCognitive'), require('../model/BingCognitiveSearchData'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MarketFeedBingCognitiveApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.MarketFeedBingCognitive, root.ForStractionServiceApi.BingCognitiveSearchData);
  }
}(this, function(ApiClient, MarketFeedBingCognitive, BingCognitiveSearchData) {
  'use strict';

  /**
   * MarketFeedBingCognitive service.
   * @module api/MarketFeedBingCognitiveApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new MarketFeedBingCognitiveApi. 
   * @alias module:api/MarketFeedBingCognitiveApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the marketFeedBingCognitiveAddAllPut operation.
     * @callback module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/MarketFeedBingCognitive>} body 
     * @param {module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.marketFeedBingCognitiveAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling marketFeedBingCognitiveAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling marketFeedBingCognitiveAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/MarketFeedBingCognitive/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the marketFeedBingCognitiveAddPut operation.
     * @callback module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/MarketFeedBingCognitive} body 
     * @param {module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.marketFeedBingCognitiveAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling marketFeedBingCognitiveAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling marketFeedBingCognitiveAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/MarketFeedBingCognitive/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the marketFeedBingCognitiveDeleteAllPut operation.
     * @callback module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.marketFeedBingCognitiveDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling marketFeedBingCognitiveDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling marketFeedBingCognitiveDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/MarketFeedBingCognitive/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the marketFeedBingCognitiveDeleteGet operation.
     * @callback module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.marketFeedBingCognitiveDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling marketFeedBingCognitiveDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling marketFeedBingCognitiveDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/MarketFeedBingCognitive/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the marketFeedBingCognitiveEditAllPut operation.
     * @callback module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/MarketFeedBingCognitive>} body 
     * @param {module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.marketFeedBingCognitiveEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling marketFeedBingCognitiveEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling marketFeedBingCognitiveEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/MarketFeedBingCognitive/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the marketFeedBingCognitiveEditPut operation.
     * @callback module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/MarketFeedBingCognitive} body 
     * @param {module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.marketFeedBingCognitiveEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling marketFeedBingCognitiveEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling marketFeedBingCognitiveEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/MarketFeedBingCognitive/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the marketFeedBingCognitiveGetSearchResultsFromBingGet operation.
     * @callback module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveGetSearchResultsFromBingGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BingCognitiveSearchData} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getSearchResultsFromBing
     * @param {String} _4SAPIAppID 
     * @param {String} keywords 
     * @param {Integer} searchType 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.market  (default to 0)
     * @param {Integer} opts.freshness  (default to 0)
     * @param {module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveGetSearchResultsFromBingGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BingCognitiveSearchData}
     */
    this.marketFeedBingCognitiveGetSearchResultsFromBingGet = function(_4SAPIAppID, keywords, searchType, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling marketFeedBingCognitiveGetSearchResultsFromBingGet";
      }

      // verify the required parameter 'keywords' is set
      if (keywords == undefined || keywords == null) {
        throw "Missing the required parameter 'keywords' when calling marketFeedBingCognitiveGetSearchResultsFromBingGet";
      }

      // verify the required parameter 'searchType' is set
      if (searchType == undefined || searchType == null) {
        throw "Missing the required parameter 'searchType' when calling marketFeedBingCognitiveGetSearchResultsFromBingGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'keywords': keywords,
        'searchType': searchType,
        'market': opts['market'],
        'freshness': opts['freshness']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = BingCognitiveSearchData;

      return this.apiClient.callApi(
        '/MarketFeedBingCognitive/getSearchResultsFromBing', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the marketFeedBingCognitiveLoadAllGet operation.
     * @callback module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/MarketFeedBingCognitive>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/MarketFeedBingCognitiveApi~marketFeedBingCognitiveLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/MarketFeedBingCognitive>}
     */
    this.marketFeedBingCognitiveLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling marketFeedBingCognitiveLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [MarketFeedBingCognitive];

      return this.apiClient.callApi(
        '/MarketFeedBingCognitive/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
